import { render, staticRenderFns } from "./CustomerBalanceForList.vue?vue&type=template&id=68f83962&"
import script from "./CustomerBalanceForList.vue?vue&type=script&lang=js&"
export * from "./CustomerBalanceForList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports